module.exports = __webpack_public_path__ + "static/media/sent_via_sms.5a368ed4.svg";